import React, { useState } from 'react';
import cn from 'classnames';

import styles from './Checkbox.module.css';

const Checkbox = ({
  onChange,
  value,
  name,
  label,
  textColor,
  children,
  size = 'md',
  theme = 'light',
  ...checkboxProps
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const changeHandler = () => {
    setIsChecked(!isChecked);

    if (onChange) onChange();
  };

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      className={`${styles.checkboxContent} relative flex items-center pl-6 cursor-pointer select-none`}
    >
      <input
        className="absolute w-0 h-0 opacity-0 cursor-pointer"
        type="checkbox"
        checked={isChecked}
        onChange={changeHandler}
        value={value}
        name={name}
        {...checkboxProps}
      />
      <span
        className={cn(
          'bg-neutral-100 w-4 h-4 absolute left-0 rounded-[4px] top-1/2 -translate-y-1/2',
          { '!w-6 !h-6': size === 'lg' },
          size === 'lg'
            ? styles.largeCheckmark
            : theme === 'dark'
            ? styles.checkmarkDark
            : styles.checkmark
        )}
      />
      {label && <span className={`text-sm ${textColor}`}>{label}</span>}
      {children}
    </label>
  );
};

Checkbox.defaultProps = {
  textColor: 'text-black'
};

export default Checkbox;
